import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const PhoneWork = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21 4H11C7.138 4 4 7.138 4 11V13C4 14.3 4.838 15.412 6 15.825V23C6 25.762 8.238 28 11 28H21C23.762 28 26 25.762 26 23V15.825C27.163 15.413 28 14.3 28 13V11C28 7.138 24.863 4 21 4ZM21 26H11C9.35 26 8 24.65 8 23V16H11C12.65 16 14 14.65 14 13V12H18V13C18 14.65 19.35 16 21 16H24V23C24 24.65 22.65 26 21 26ZM26 13C26 13.55 25.55 14 25 14H21C20.45 14 20 13.55 20 13V11C20 10.45 19.55 10 19 10H13C12.45 10 12 10.45 12 11V13C12 13.55 11.55 14 11 14H7C6.45 14 6 13.55 6 13V11C6 8.238 8.238 6 11 6H21C23.762 6 26 8.238 26 11V13Z" />
		<path d="M22 23C22 23.552 21.552 24 21 24C20.448 24 20 23.552 20 23C20 22.448 20.448 22 21 22C21.552 22 22 22.448 22 23Z" />
		<path d="M17 23C17 23.552 16.552 24 16 24C15.448 24 15 23.552 15 23C15 22.448 15.448 22 16 22C16.552 22 17 22.448 17 23Z" />
		<path d="M12 23C12 23.552 11.552 24 11 24C10.448 24 10 23.552 10 23C10 22.448 10.448 22 11 22C11.552 22 12 22.448 12 23Z" />
		<path d="M22 19C22 19.552 21.552 20 21 20C20.448 20 20 19.552 20 19C20 18.448 20.448 18 21 18C21.552 18 22 18.448 22 19Z" />
		<path d="M17 19C17 19.552 16.552 20 16 20C15.448 20 15 19.552 15 19C15 18.448 15.448 18 16 18C16.552 18 17 18.448 17 19Z" />
		<path d="M12 19C12 19.552 11.552 20 11 20C10.448 20 10 19.552 10 19C10 18.448 10.448 18 11 18C11.552 18 12 18.448 12 19Z" />
	</svg>
);

export default PhoneWork;
